import { useEffect, useRef, useState } from "react";

/**
 * Multi-select com checkboxes e opção "Todos".
 * options: [{ id, value }]
 * selectedIds: array de ids selecionados ([] === todos)
 * onChange: (novoArrayDeIds) => void
 */
function MultiSelect({ options, selectedIds, onChange, placeholder = "Todos" }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickFora = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickFora);
    return () => document.removeEventListener("mousedown", handleClickFora);
  }, []);

  const toggleOption = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((sid) => sid !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const selecionarTodos = () => onChange([]);

  const textoResumo = () => {
    if (!selectedIds || selectedIds.length === 0) return placeholder;
    const nomes = options
      .filter((o) => selectedIds.includes(o.id))
      .map((o) => o.value);
    if (nomes.length <= 2) return nomes.join(", ");
    return `${nomes.length} selecionados`;
  };

  return (
    <div className="financeiro__modalFiltros__multiselect" ref={containerRef}>
      <button
        type="button"
        className="financeiro__modalFiltros__multiselect__trigger"
        onClick={() => setOpen((o) => !o)}
      >
        <span className="financeiro__modalFiltros__multiselect__trigger-text">
          {textoResumo()}
        </span>
        <span className="financeiro__modalFiltros__multiselect__caret">▾</span>
      </button>

      {open && (
        <div className="financeiro__modalFiltros__multiselect__dropdown">
          <label className="financeiro__modalFiltros__multiselect__option">
            <input
              type="checkbox"
              checked={!selectedIds || selectedIds.length === 0}
              onChange={selecionarTodos}
            />
            <span>{placeholder}</span>
          </label>
          {options.map((option) => (
            <label
              key={option.id}
              className="financeiro__modalFiltros__multiselect__option"
            >
              <input
                type="checkbox"
                checked={selectedIds.includes(option.id)}
                onChange={() => toggleOption(option.id)}
              />
              <span>{option.value}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default MultiSelect;
